export default "__VITE_ASSET__pcdvxB7g__"